var exports = {
  "iE": "xaee3c4fa--2b869a--wrapper",
  "R_": "xaee3c4fa--2b869a--heading",
  "Zd": "xaee3c4fa--2b869a--form",
  "ZZ": "xaee3c4fa--2b869a--field",
};

module.exports = exports;
